import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, Route } from '@angular/router';
import { isEqual } from 'lodash';

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    if (this._isLeavingChildThatResetsItsParent(future, current)) {
      return false;
    }

    const isSameRoute = future.routeConfig === current.routeConfig;
    const isSameComponentConfig =
      !!future.routeConfig?.component &&
      future.routeConfig?.component === current.routeConfig?.component &&
      future.routeConfig?.path === current.routeConfig?.path;
    const isSameRouteParams = isEqual(future.params, current.params);

    return (isSameRoute || isSameComponentConfig) && isSameRouteParams;
  }

  private _isLeavingChildThatResetsItsParent(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    const currentChildConfig: Route = current.firstChild?.routeConfig;
    const futureChildConfig: Route = future.firstChild?.routeConfig;
    const doesCurrentChildResetItsParent: boolean = !!currentChildConfig?.data?.resetParentOnLeave;

    return doesCurrentChildResetItsParent && currentChildConfig.path !== futureChildConfig?.path;
  }
}
